import styled from 'styled-components';

export const TrustedRentalContainer = styled.div`
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "PingFang TC", "Microsoft JhengHei", "Helvetica Neue", Arial, sans-serif;
  color: #333;
  line-height: 1.6;
  background-color: #fff;
`;

export const Header = styled.header`
  background-color: #fff;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
  position: fixed;
  width: 100%;
  top: 0;
  z-index: 1000;
`;

export const Nav = styled.nav`
  max-width: 1200px;
  margin: 0 auto;
  padding: 1rem;
  display: flex;
  justify-content: space-between;
  align-items: center;

  @media (max-width: 768px) {
    flex-direction: column;
    text-align: center;
  }
`;

export const Logo = styled.div`
  font-size: 1.5rem;
  font-weight: bold;
  color: #333;
`;

export const NavLinks = styled.ul`
  display: flex;
  list-style: none;
  margin: 0;
  padding: 0;

  @media (max-width: 768px) {
    margin-top: 1rem;
    flex-direction: column;
  }
`;

export const NavItem = styled.li`
  margin-left: 2rem;

  @media (max-width: 768px) {
    margin: 0.5rem 0;
  }
`;

export const NavLink = styled.a`
  text-decoration: none;
  color: #666;
  font-weight: 400;
  transition: color 0.3s ease;

  &:hover {
    color: #333;
  }
`;

export const Main = styled.main`
  margin-top: 80px;
`;

export const Hero = styled.section`
  background: #F5F5F3;
  color: #333;
  text-align: center;
  padding: 6rem 2rem;
  position: relative;
  overflow: hidden;

  h1 {
    font-size: 2.5rem;
    margin-bottom: 1rem;
    color: #333;
  }

  h2 {
    font-size: 1.8rem;
    margin-bottom: 2rem;
    color: #666;
  }
`;

export const Highlight = styled.div`
  background-color: #fff;
  padding: 1rem 2rem;
  border-radius: 4px;
  display: inline-block;
  margin-bottom: 2rem;
  color: #333;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
`;

export const CTAButton = styled.button`
  background-color: #333;
  color: white;
  border: none;
  padding: 1rem 2rem;
  font-size: 1.1rem;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.3s ease;

  &:hover {
    background-color: #444;
  }
`;

export const Problems = styled.section`
  padding: 4rem 2rem;
  background-color: #fff;

  h2 {
    text-align: center;
    margin-bottom: 3rem;
    color: #333;
  }
`;

export const ProblemsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 2rem;
  max-width: 1200px;
  margin: 0 auto;
`;

export const ProblemCard = styled.div`
  background: #F5F5F3;
  padding: 2rem;
  border-radius: 4px;
  text-align: center;

  h3 {
    color: #333;
    margin-bottom: 1rem;
  }

  p {
    color: #666;
  }
`;

export const Process = styled.section`
  padding: 4rem 2rem;
  background-color: #F5F5F3;

  h2 {
    text-align: center;
    margin-bottom: 3rem;
    color: #333;
  }
`;

export const ProcessSteps = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 2rem;
`;

export const Step = styled.div`
  background: #fff;
  padding: 2rem;
  border-radius: 4px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);

  h3 {
    color: #333;
    margin-bottom: 1rem;
  }

  p {
    color: #666;
  }
`;

export const ContactForm = styled.section`
  background-color: #fff;
  padding: 4rem 2rem;

  h2 {
    text-align: center;
    margin-bottom: 1rem;
    color: #333;
  }

  > p {
    text-align: center;
    margin-bottom: 2rem;
    color: #666;
  }
`;

export const Form = styled.form`
  max-width: 600px;
  margin: 0 auto;
`;

export const FormGroup = styled.div`
  margin-bottom: 1.5rem;

  label {
    display: block;
    margin-bottom: 0.5rem;
    color: #333;
    font-weight: 400;
  }

  input,
  select,
  textarea {
    width: 100%;
    padding: 0.75rem;
    border: 1px solid #E0E0E0;
    border-radius: 4px;
    font-size: 1rem;
    background-color: #F5F5F3;
    color: #333;

    &:focus {
      outline: none;
      border-color: #666;
      background-color: #fff;
    }
  }

  textarea {
    height: 150px;
    resize: vertical;
  }
`;

export const SubmitButton = styled.button`
  background-color: #333;
  color: white;
  border: none;
  padding: 1rem 2rem;
  font-size: 1.1rem;
  border-radius: 4px;
  cursor: pointer;
  width: 100%;
  transition: background-color 0.3s ease;

  &:hover {
    background-color: #444;
  }
`;

export const Footer = styled.footer`
  background-color: #F5F5F3;
  color: #666;
  padding: 4rem 2rem 2rem;
`;

export const FooterContent = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 2rem;
`;

export const FooterSection = styled.div`
  h4 {
    color: #333;
    margin-bottom: 1rem;
  }

  p {
    margin-bottom: 0.5rem;
    color: #666;
  }
`;

export const FooterBottom = styled.div`
  text-align: center;
  margin-top: 2rem;
  padding-top: 2rem;
  border-top: 1px solid #E0E0E0;
  color: #999;
`; 